import { publish } from 'helpers/pubsub';
import { UnavailableInspirationsRemovedError } from '.';

const handleInspirationsRemovedError = (inspirationsRemovedError: UnavailableInspirationsRemovedError) => {
    publish('UNAVAILABLE_INSPIRATIONS_REMOVED', inspirationsRemovedError.data?.removed_inspirations?.length ?? 1);
};

export default handleInspirationsRemovedError;
